import { render, staticRenderFns } from "./GraduateStudentArchive.vue?vue&type=template&id=41bb047c&scoped=true"
import script from "./GraduateStudentArchive.vue?vue&type=script&lang=js"
export * from "./GraduateStudentArchive.vue?vue&type=script&lang=js"
import style0 from "./GraduateStudentArchive.vue?vue&type=style&index=0&id=41bb047c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bb047c",
  null
  
)

export default component.exports